import {createRouter, createWebHistory} from 'vue-router';
import routes from '@/web/router/routes';
import {authRequired, checkLanguage, checkPermission} from '@/web/router/hooks';
import {emitGaPageView} from '@/features/common/compositions/useAnalytics.js';

const router = createRouter({
    history: createWebHistory('/web/'),
    routes,
});

router.beforeEach(authRequired);
router.beforeEach(checkPermission);
router.beforeEach(checkLanguage);
router.afterEach(emitGaPageView);

export default router;
